module.exports = __webpack_public_path__ + "img/logo-8.da8688a8.svg";